import axios from "axios";
import { apiConfig } from "../config/authConfig";
import { CredentialManager } from "../classes/credentialManager";

import { ICustomerGeneratorStatusOption, ICustomerStatusOption, ISelectOption, ISelectOptionWithEntity } from "../types/list";
import { UtilityService } from "./utilityService";
import { IExpense } from "../types/expense";
import { IReportRegistration } from "../types/report";

export namespace ListService {
	const credentialManager = CredentialManager.getInstance();

	/**********
	 * Gets all select options for all dropdowns to load into context.
	 **********/
	export async function getSelectOptions() {
		const apiResponse = axios.get(
			apiConfig.default + "/list/selectoptions",
			{
				headers: {
					'Authorization': `Bearer ${await credentialManager.getAccessToken()}`
				},
			}
		)

		return apiResponse;
	}

	/**********
	 * Convert api response data to array of customerStatusOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapCustomerStatusOptions(data: any) {
		let options: ICustomerStatusOption[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					value: item.id,
					name: item.name,
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of customerGeneratorStatusOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapCustomerGeneratorStatusOptions(data: any) {
		let options: ICustomerGeneratorStatusOption[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					value: item.value,
					name: item.name,
					description: item.description
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of selectOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapEntityTypeOptions(data: any) {
		let options: ISelectOption[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					value: item.value,
					name: item.name,
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of IExpense objects.
	 * @param data Response data from an API.
	 **********/
	export function mapExpenseOptions(data: any) {
		let options: IExpense[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					id: item.id,
					name: item.name || '',
					category: item.category || '',
					process: item.process || '',
					spreadAcrossMaterials: item.spreadAcrossMaterials,
					isActive: item.isActive
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of selectOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapDocumentTypeOptions(data: any) {
		let options: ISelectOptionWithEntity[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					value: item.value,
					name: item.name,
					type: item.entityTypeId
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of selectOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapEmployeeOptions(data: any) {
		let options: ISelectOption[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					value: item.value,
					name: item.name,
					isActive: item.isActive,
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of stateOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapStateOptions(data: any) {
		let options: ISelectOption[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					name: item.name,
					value: item.abbreviation
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of stateOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapVendorOptions(data: any) {
		let options: ISelectOption[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					name: item.name,
					value: item.value,
					isActive: item.isActive,
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of stateOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapVendorMethodOptions(data: any) {
		let options: ISelectOption[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					name: item.name,
					value: item.value
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of selectOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapVendorStatusOptions(data: any) {
		let options: ISelectOption[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					name: item.name,
					value: item.value
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of stateOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapCustomerOptions(data: any) {
		let options: ISelectOption[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					name: item.name,
					value: item.value,
					isActive: item.isActive,
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of stateOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapBrandOptions(data: any) {
		let options: ISelectOption[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					name: item.name,
					value: item.value
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of selectOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapWasteTypeOptions(data: any) {
		let options: ISelectOption[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					name: item.name,
					value: item.value
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of selectOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapTrailerTypeOptions(data: any) {
		let options: ISelectOption[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					name: item.name,
					value: item.value
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of selectOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapTransporterOptions(data: any) {
		let options: ISelectOption[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					name: item.name,
					value: item.value,
					isActive: item.isActive,
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of ISelectOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapUnitsOfMeasurement(data: any) {
		let options: ISelectOption[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					name: item.name,
					value: item.value
				});
			})
		}

		return options.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
	}

	/**********
	 * Convert api response data to array of selectOption objects.
	 * @param data Response data from an API.
	 **********/
	export function mapMaterialOptions(data: any) {
		let options: ISelectOption[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					name: item.name,
					value: item.value
				});
			})
		}
		
		// Materials are custom pre-sorted in the API
		return options;
	}

	/**********
	 * Convert api response data to array of IReportRegistration objects.
	 * @param data Response data from an API.
	 **********/
	export function mapReportRegistrations(data: any) {
		let options: IReportRegistration[] = [];

		if (Array.isArray(data) && data.length > 0) {
			data.map((item: any, index) => {
				options.push({
					id: item.id,
					type: item.type,
					reportId: item.reportId,
					workspaceId: item.workspaceId,
					name: item.name,
					displayName: item.displayName,
					permission: item.permission,
					ordinal: item.ordinal,
					active: item.active,
				});
			})
		}
		
		// Report registrations are pre-sorted in the API
		return options;
	}
}
